export const strings = {
  de: {
    nav: {
      services: 'Leistungen',
      hosting: 'Hosting & Cloud',
      about: 'Über uns',
      contact: 'Kontakt',
      portal: 'Kundenportal',
      login: 'Login',
      requestOffer: 'Angebot anfordern',
      allServices: 'Alle Leistungen',
    },
    hero: {
      badge: 'Die IT-Plattform der Zukunft · 2030',
      title1: 'Eine Welt.',
      title2: 'Ihre komplette IT.',
      subtitle: 'Netzwerke, Server & Cloud, Softwareentwicklung, Cybersecurity, Hosting und KI – Ihre komplette IT-Infrastruktur aus einer Hand. Programmiert, vernetzt und abgesichert.',
      ctaPrimary: 'Angebot anfordern',
      ctaSecondary: 'Leistungen entdecken',
      trust1: 'Eigene Infrastruktur',
      trust2: '24/7 Monitoring',
      trust3: 'Security by Design',
    },
    sections: {
      servicesTitle: 'Ein Technologie-Universum',
      servicesSubtitle: 'Alle IT-Leistungen aus einer Hand – nahtlos integriert.',
      processTitle: 'So arbeiten wir',
      processSubtitle: 'Klar strukturiert, transparent, verlässlich.',
      statsTitle: 'Zahlen, die überzeugen',
      testimonialsTitle: 'Was Kunden sagen',
      certsTitle: 'Zertifiziert & vertrauenswürdig',
      faqTitle: 'Häufige Fragen',
      ctaBandTitle: 'Bereit für die beste IT-Erfahrung?',
      ctaBandText: 'Lassen Sie uns über Ihr Projekt sprechen – unverbindlich und auf Augenhöhe.',
      platformTitle: 'Eine Plattform. Alle Systeme.',
      platformSubtitle: 'Klicken Sie sich durch – jede Leistung mit echter Live-Oberfläche.',
      platformExplore: 'Leistung ansehen',
      whyTitle: 'Warum IT-WELT360?',
      whySubtitle: 'Der Unterschied zu Standard-Anbietern.',
      whyUs: 'IT-WELT360',
      whyThem: 'Standard-Anbieter',
      techTitle: 'Technologien, mit denen wir arbeiten',
      learnMore: 'Mehr erfahren',
    },
    service: {
      whatWeOffer: 'Unsere Leistungen',
      outcomes: 'Ihre Vorteile',
      deepTitle: 'Im Detail',
      specsTitle: 'Spezifikationen',
      useCasesTitle: 'Typische Anwendungsfälle',
      stackTitle: 'Technologien & Standards',
      faqTitle: 'Häufige Fragen',
      ctaTitle: 'Interesse geweckt?',
      ctaText: 'Fordern Sie ein unverbindliches Angebot an oder sprechen Sie mit unserem KI-Assistenten.',
      backToServices: 'Alle Leistungen',
    },
    offer: {
      title: 'Angebot anfordern',
      subtitle: 'Wir melden uns innerhalb von 24 Stunden.',
      name: 'Name', company: 'Firma', email: 'E-Mail', phone: 'Telefon',
      service: 'Leistung', budget: 'Budget', message: 'Nachricht',
      submit: 'Anfrage senden', sending: 'Wird gesendet...',
      success: 'Vielen Dank! Wir melden uns in Kürze.',
      error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
      selectService: 'Bitte wählen',
      budgetRanges: ['< 1.000 €', '1.000 – 5.000 €', '5.000 – 20.000 €', '> 20.000 €'],
    },
    contact: {
      title: 'Kontakt',
      subtitle: 'Sprechen Sie mit uns – wir freuen uns auf Ihr Projekt.',
      responseTime: 'Antwort in < 24h', hotline: 'Hotline', whatsapp: 'WhatsApp Chat',
      sendMessage: 'Nachricht senden',
    },
    repair: {
      kicker: 'Geräte-Reparatur · Werkstatt & Vor-Ort',
      title: 'Reparatur, die man vertraut.',
      subtitle: 'PC, Mac, Smartphone, Tablet, Konsole & Drucker – professionell repariert. Kostenlose Diagnose, verbindlicher Festpreis, DSGVO-konforme Datenrettung und Garantie.',
      ctaForm: 'Reparatur anfragen',
      ctaCall: 'Anrufen',
      badges: { fixedPrice: 'Festpreis vorab', privacy: 'DSGVO & Datenschutz', warranty: 'Garantie', express: 'Express möglich' },
      categoriesTitle: 'Was wir reparieren',
      categoriesSubtitle: 'Von der Displayreparatur bis zur Datenrettung – alles aus einer Hand.',
      processTitle: 'So läuft Ihre Reparatur',
      processSubtitle: 'Transparent in fünf Schritten – ohne Überraschungen.',
      process: [
        { title: 'Diagnose', text: 'Kostenlose, gründliche Fehlerdiagnose Ihres Geräts.' },
        { title: 'Kostenvoranschlag', text: 'Verbindlicher Festpreis – Sie entscheiden in Ruhe.' },
        { title: 'Reparatur', text: 'Fachgerechte Reparatur mit Qualitäts-Ersatzteilen.' },
        { title: 'Qualitätscheck', text: 'Umfassender Funktionstest vor der Rückgabe.' },
        { title: 'Rückgabe', text: 'Abholung, Versand oder Vor-Ort-Übergabe inkl. Garantie.' },
      ],
      trustTitle: 'Warum IT-WELT360 für Ihre Reparatur',
      trust: [
        { title: 'Festpreis-Garantie', text: 'Klarer Preis vor der Reparatur – keine versteckten Kosten.' },
        { title: 'Datenschutz', text: 'Ihre Daten bleiben vertraulich – DSGVO-konform.' },
        { title: 'Garantie', text: 'Auf Reparatur und Ersatzteile geben wir Garantie.' },
        { title: 'Express & Vor-Ort', text: 'Schnellservice und Vor-Ort-Termine für Unternehmen.' },
      ],
      form: {
        title: 'Reparatur-Anfrage',
        subtitle: 'Beschreiben Sie Ihr Gerät und das Problem – wir melden uns mit Diagnose & Festpreis.',
        deviceSection: 'Gerätedaten',
        contactSection: 'Kontaktdaten',
        attachSection: 'Fotos & Anhänge',
        deviceType: 'Gerätetyp',
        deviceTypePlaceholder: 'Bitte wählen',
        deviceTypes: ['PC / Desktop', 'Laptop / Notebook', 'Mac / MacBook', 'Smartphone', 'Tablet', 'Spielkonsole', 'Drucker', 'Festplatte / SSD (Datenrettung)', 'Sonstiges'],
        manufacturer: 'Hersteller',
        manufacturerPlaceholder: 'z. B. Apple, Lenovo, Samsung',
        model: 'Modell',
        modelPlaceholder: 'z. B. MacBook Pro 14"',
        serial: 'Seriennummer (optional)',
        serialPlaceholder: 'z. B. C02X… (falls bekannt)',
        powersOn: 'Startet das Gerät?',
        powersYes: 'Ja',
        powersNo: 'Nein',
        powersUnknown: 'Unsicher',
        urgency: 'Dringlichkeit',
        urgencyPlaceholder: 'Bitte wählen',
        urgencyOptions: ['Standard', 'Bald', 'Express (schnellstmöglich)'],
        preferredDate: 'Wunschtermin (optional)',
        preferredDatePlaceholder: 'Datum wählen',
        errorDescription: 'Fehlerbeschreibung',
        errorPlaceholder: 'Was funktioniert nicht? Seit wann? Gab es einen Sturz oder Wasserschaden?',
        name: 'Name', email: 'E-Mail', phone: 'Telefon', company: 'Firma (optional)',
        dropzoneIdle: 'Fotos/Dateien hier ablegen oder klicken zum Auswählen',
        dropzoneBrowse: 'Durchsuchen',
        dropzoneHelper: 'PNG, JPG, WEBP oder PDF · max. 10 Dateien · je 15 MB',
        uploading: 'Wird hochgeladen…',
        submit: 'Reparatur-Anfrage senden',
        sending: 'Wird gesendet…',
        success: 'Vielen Dank! Ihre Reparatur-Anfrage ist eingegangen. Wir melden uns mit Diagnose & Festpreis.',
        successTitle: 'Anfrage gesendet',
        errorRequired: 'Bitte Gerätetyp, Fehlerbeschreibung, Name und E-Mail angeben.',
        errorUpload: 'Datei-Upload fehlgeschlagen. Bitte erneut versuchen.',
        removeFile: 'Entfernen',
        newRequest: 'Weitere Anfrage',
      },
    },
    about: {
      title: 'Die beste IT-Firma. Punkt.',
      subtitle: 'IT-WELT360 vereint jahrelange Erfahrung, eigene Infrastruktur und kompromisslose Qualität.',
      missionTitle: 'Unsere Mission',
      mission: 'Wir machen erstklassige IT für Unternehmen jeder Größe zugänglich – mit einer Plattform, die Hosting, Software, Sicherheit und KI nahtlos vereint.',
      valuesTitle: 'Wofür wir stehen',
    },
    auth: {
      loginTitle: 'Willkommen zurück', loginSubtitle: 'Melden Sie sich in Ihrem Kundenportal an.',
      registerTitle: 'Konto erstellen', registerSubtitle: 'Verwalten Sie Ihre Services an einem Ort.',
      email: 'E-Mail', password: 'Passwort', name: 'Name', company: 'Firma',
      loginBtn: 'Anmelden', registerBtn: 'Registrieren',
      noAccount: 'Noch kein Konto?', hasAccount: 'Bereits registriert?',
      toRegister: 'Jetzt registrieren', toLogin: 'Zum Login',
      demoHint: 'Demo-Zugang: demo@it-welt360.de / demo1234',
      invalid: 'Ungültige Anmeldedaten', loggingIn: 'Anmeldung...',
    },
    portal: {
      title: 'Kundenportal', welcome: 'Willkommen',
      logout: 'Abmelden', overview: 'Übersicht',
      tickets: 'Tickets', invoices: 'Rechnungen', services: 'Services', security: 'Sicherheit',
      noTickets: 'Keine offenen Tickets', noInvoices: 'Keine offenen Rechnungen',
      noServices: 'Noch keine Services aktiv', foundation: 'Portal-Grundgerüst – weitere Funktionen folgen.',
      securityScore: 'Sicherheits-Score',
    },
    ai: {
      title: 'NOVA – KI-Assistent', status: 'Online · Angebots- & Support-Assistent',
      placeholder: 'Stellen Sie Ihre Frage...', greeting: 'Hallo! Ich bin NOVA, Ihr KI-Assistent von IT-WELT360. Wie kann ich Ihnen helfen – Hosting, JTL, Kassensysteme, Sicherheit oder ein Angebot?',
      send: 'Senden', thinking: 'NOVA denkt nach...',
    },
    noc: {
      kicker: 'Live · Globales Abwehrnetz',
      title: 'Globale Bedrohungsabwehr in Echtzeit',
      subtitle: 'Unser Security Operations Center überwacht Ihre Infrastruktur rund um die Uhr – weltweit verteilt, in Millisekunden reagierend.',
      live: 'LIVE', nodesOnline: 'Knoten online', arcsLabel: 'Aktive Routen',
      threatsBlocked: 'Bedrohungen blockiert', latency: 'Latenz', rps: 'Anfragen / Sek.',
      liveFeed: 'Live-Ereignisse', autoRefresh: 'auto-refresh',
    },
    matrix: {
      activated: 'MATRIX MODE aktiviert',
      hint: 'Drücke ESC zum Beenden',
      subtitle: 'Willkommen im Kaninchenbau. Die Realität ist optional.',
      exit: 'Beenden',
    },
    cmd: {
      matrix: 'Matrix-Modus umschalten',
      noc: 'Zum Live-Abwehrnetz springen',
      top: 'Nach oben scrollen',
      quote: 'Angebots-Assistent öffnen',
      groupFun: 'Extras',
    },
    wizard: {
      title: 'Angebots-Assistent', subtitle: 'In unter 2 Minuten zum passenden Angebot.',
      step: 'Schritt', of: 'von', next: 'Weiter', back: 'Zurück',
      submit: 'Anfrage absenden', sending: 'Wird gesendet...',
      stepServiceTitle: 'Welche Leistung interessiert Sie?',
      stepServiceSubtitle: 'Wählen Sie einen Schwerpunkt aus.',
      stepScopeTitle: 'Was benötigen Sie konkret?',
      stepScopeSubtitle: 'Wählen Sie alles Passende aus (optional).',
      stepBudgetTitle: 'Budget & Zeitrahmen',
      stepBudgetSubtitle: 'Damit wir Ihr Angebot realistisch kalkulieren.',
      stepContactTitle: 'Wohin dürfen wir das Angebot senden?',
      stepContactSubtitle: 'Wir melden uns innerhalb von 24 Stunden.',
      budgetLabel: 'Budget', timelineLabel: 'Zeitrahmen',
      timelines: ['So schnell wie möglich', 'In 1–3 Monaten', 'In 3–6 Monaten', 'Noch in Planung'],
      scopeOptions: ['Neuaufbau / Migration', 'Laufender Betrieb & Support', '24/7 Monitoring', 'Beratung & Konzept', 'Sicherheit & Compliance', 'Skalierung / Performance'],
      success: 'Vielen Dank! Ihre Anfrage ist eingegangen – wir melden uns in Kürze.',
      successTitle: 'Anfrage gesendet',
      selectServiceFirst: 'Bitte wählen Sie zuerst eine Leistung.',
      contactError: 'Bitte Name und E-Mail angeben.',
      name: 'Name', company: 'Firma', email: 'E-Mail', phone: 'Telefon', message: 'Nachricht (optional)',
      summary: 'Ihre Auswahl',
    },
    footer: {
      tagline: 'Die IT-Plattform der Zukunft.',
      services: 'Leistungen', company: 'Unternehmen', legal: 'Rechtliches',
      imprint: 'Impressum', privacy: 'Datenschutz', terms: 'AGB',
      rights: 'Alle Rechte vorbehalten.',
    },
  },
  en: {
    nav: {
      services: 'Services', hosting: 'Hosting & Cloud', about: 'About', contact: 'Contact',
      portal: 'Customer Portal', login: 'Login', requestOffer: 'Request a quote', allServices: 'All services',
    },
    hero: {
      badge: 'The IT platform of the future · 2030',
      title1: 'One world.', title2: 'All your IT.',
      subtitle: 'Networks, servers & cloud, software development, cybersecurity, hosting and AI – your entire IT infrastructure from one source. Coded, connected and secured.',
      ctaPrimary: 'Request a quote', ctaSecondary: 'Explore services',
      trust1: 'Own infrastructure', trust2: '24/7 monitoring', trust3: 'Security by design',
    },
    sections: {
      servicesTitle: 'A technology universe',
      servicesSubtitle: 'All IT services from one source – seamlessly integrated.',
      processTitle: 'How we work', processSubtitle: 'Clearly structured, transparent, reliable.',
      statsTitle: 'Numbers that convince', testimonialsTitle: 'What clients say',
      certsTitle: 'Certified & trustworthy', faqTitle: 'Frequently asked questions',
      ctaBandTitle: 'Ready for the best IT experience?',
      ctaBandText: 'Let\u2019s talk about your project – no obligations, just expertise.',
      platformTitle: 'One platform. Every system.',
      platformSubtitle: 'Click through – every service with a real live interface.',
      platformExplore: 'View service',
      whyTitle: 'Why IT-WELT360?',
      whySubtitle: 'The difference from standard providers.',
      whyUs: 'IT-WELT360',
      whyThem: 'Standard provider',
      techTitle: 'Technologies we work with',
      learnMore: 'Learn more',
    },
    service: {
      whatWeOffer: 'What we offer', outcomes: 'Your benefits',
      deepTitle: 'In detail', specsTitle: 'Specifications', useCasesTitle: 'Typical use cases', stackTitle: 'Technologies & standards',
      faqTitle: 'FAQ',
      ctaTitle: 'Interested?', ctaText: 'Request a free quote or chat with our AI assistant.',
      backToServices: 'All services',
    },
    offer: {
      title: 'Request a quote', subtitle: 'We will get back to you within 24 hours.',
      name: 'Name', company: 'Company', email: 'Email', phone: 'Phone',
      service: 'Service', budget: 'Budget', message: 'Message',
      submit: 'Send request', sending: 'Sending...',
      success: 'Thank you! We will be in touch shortly.',
      error: 'Something went wrong. Please try again.',
      selectService: 'Please select',
      budgetRanges: ['< €1,000', '€1,000 – 5,000', '€5,000 – 20,000', '> €20,000'],
    },
    contact: {
      title: 'Contact', subtitle: 'Talk to us – we look forward to your project.',
      responseTime: 'Reply in < 24h', hotline: 'Hotline', whatsapp: 'WhatsApp chat', sendMessage: 'Send message',
    },
    repair: {
      kicker: 'Device Repair · Workshop & On-site',
      title: 'Repairs you can trust.',
      subtitle: 'PC, Mac, smartphone, tablet, console & printer – professionally repaired. Free diagnostics, binding fixed price, GDPR-compliant data recovery and warranty.',
      ctaForm: 'Request repair',
      ctaCall: 'Call us',
      badges: { fixedPrice: 'Fixed price upfront', privacy: 'GDPR & privacy', warranty: 'Warranty', express: 'Express available' },
      categoriesTitle: 'What we repair',
      categoriesSubtitle: 'From screen repair to data recovery – all from one source.',
      processTitle: 'How your repair works',
      processSubtitle: 'Transparent in five steps – no surprises.',
      process: [
        { title: 'Diagnostics', text: 'Free, thorough fault diagnosis of your device.' },
        { title: 'Quote', text: 'Binding fixed price – you decide at your leisure.' },
        { title: 'Repair', text: 'Expert repair using quality spare parts.' },
        { title: 'Quality check', text: 'Comprehensive function test before handover.' },
        { title: 'Handover', text: 'Pickup, shipping or on-site handover incl. warranty.' },
      ],
      trustTitle: 'Why IT-WELT360 for your repair',
      trust: [
        { title: 'Fixed-price guarantee', text: 'Clear price before the repair – no hidden costs.' },
        { title: 'Data privacy', text: 'Your data stays confidential – GDPR-compliant.' },
        { title: 'Warranty', text: 'We provide warranty on repairs and spare parts.' },
        { title: 'Express & on-site', text: 'Fast service and on-site appointments for businesses.' },
      ],
      form: {
        title: 'Repair request',
        subtitle: 'Describe your device and the problem – we get back with diagnosis & fixed price.',
        deviceSection: 'Device details',
        contactSection: 'Contact',
        attachSection: 'Photos & attachments',
        deviceType: 'Device type',
        deviceTypePlaceholder: 'Please select',
        deviceTypes: ['PC / Desktop', 'Laptop / Notebook', 'Mac / MacBook', 'Smartphone', 'Tablet', 'Game console', 'Printer', 'Hard drive / SSD (data recovery)', 'Other'],
        manufacturer: 'Manufacturer',
        manufacturerPlaceholder: 'e.g. Apple, Lenovo, Samsung',
        model: 'Model',
        modelPlaceholder: 'e.g. MacBook Pro 14"',
        serial: 'Serial number (optional)',
        serialPlaceholder: 'e.g. C02X… (if known)',
        powersOn: 'Does the device power on?',
        powersYes: 'Yes',
        powersNo: 'No',
        powersUnknown: 'Not sure',
        urgency: 'Urgency',
        urgencyPlaceholder: 'Please select',
        urgencyOptions: ['Standard', 'Soon', 'Express (asap)'],
        preferredDate: 'Preferred date (optional)',
        preferredDatePlaceholder: 'Pick a date',
        errorDescription: 'Problem description',
        errorPlaceholder: 'What is not working? Since when? Any drop or water damage?',
        name: 'Name', email: 'Email', phone: 'Phone', company: 'Company (optional)',
        dropzoneIdle: 'Drop photos/files here or click to browse',
        dropzoneBrowse: 'Browse',
        dropzoneHelper: 'PNG, JPG, WEBP or PDF · max. 10 files · 15 MB each',
        uploading: 'Uploading…',
        submit: 'Send repair request',
        sending: 'Sending…',
        success: 'Thank you! Your repair request has been received. We will get back with diagnosis & fixed price.',
        successTitle: 'Request sent',
        errorRequired: 'Please provide device type, problem description, name and email.',
        errorUpload: 'File upload failed. Please try again.',
        removeFile: 'Remove',
        newRequest: 'New request',
      },
    },
    about: {
      title: 'The best IT company. Period.',
      subtitle: 'IT-WELT360 combines years of experience, own infrastructure and uncompromising quality.',
      missionTitle: 'Our mission',
      mission: 'We make first-class IT accessible to companies of every size – with a platform that unifies hosting, software, security and AI.',
      valuesTitle: 'What we stand for',
    },
    auth: {
      loginTitle: 'Welcome back', loginSubtitle: 'Sign in to your customer portal.',
      registerTitle: 'Create account', registerSubtitle: 'Manage your services in one place.',
      email: 'Email', password: 'Password', name: 'Name', company: 'Company',
      loginBtn: 'Sign in', registerBtn: 'Register',
      noAccount: 'No account yet?', hasAccount: 'Already registered?',
      toRegister: 'Register now', toLogin: 'Go to login',
      demoHint: 'Demo access: demo@it-welt360.de / demo1234',
      invalid: 'Invalid credentials', loggingIn: 'Signing in...',
    },
    portal: {
      title: 'Customer Portal', welcome: 'Welcome', logout: 'Logout', overview: 'Overview',
      tickets: 'Tickets', invoices: 'Invoices', services: 'Services', security: 'Security',
      noTickets: 'No open tickets', noInvoices: 'No open invoices',
      noServices: 'No active services yet', foundation: 'Portal foundation – more features coming soon.',
      securityScore: 'Security score',
    },
    ai: {
      title: 'NOVA – AI Assistant', status: 'Online · Sales & support assistant',
      placeholder: 'Ask your question...', greeting: 'Hi! I\u2019m NOVA, your AI assistant at IT-WELT360. How can I help – hosting, JTL, POS, security or a quote?',
      send: 'Send', thinking: 'NOVA is thinking...',
    },
    noc: {
      kicker: 'Live · Global Defense Grid',
      title: 'Global threat defense, in real time',
      subtitle: 'Our Security Operations Center watches your infrastructure around the clock – globally distributed, reacting in milliseconds.',
      live: 'LIVE', nodesOnline: 'Nodes online', arcsLabel: 'Active routes',
      threatsBlocked: 'Threats blocked', latency: 'Latency', rps: 'Requests / sec',
      liveFeed: 'Live events', autoRefresh: 'auto-refresh',
    },
    matrix: {
      activated: 'MATRIX MODE activated',
      hint: 'Press ESC to exit',
      subtitle: 'Welcome to the rabbit hole. Reality is optional.',
      exit: 'Exit',
    },
    cmd: {
      matrix: 'Toggle Matrix Mode',
      noc: 'Jump to live defense grid',
      top: 'Scroll to top',
      quote: 'Open quote assistant',
      groupFun: 'Extras',
    },
    wizard: {
      title: 'Quote assistant', subtitle: 'A tailored quote in under 2 minutes.',
      step: 'Step', of: 'of', next: 'Next', back: 'Back',
      submit: 'Send request', sending: 'Sending...',
      stepServiceTitle: 'Which service are you interested in?',
      stepServiceSubtitle: 'Pick a focus area.',
      stepScopeTitle: 'What exactly do you need?',
      stepScopeSubtitle: 'Select everything that fits (optional).',
      stepBudgetTitle: 'Budget & timeline',
      stepBudgetSubtitle: 'So we can scope your quote realistically.',
      stepContactTitle: 'Where should we send the quote?',
      stepContactSubtitle: 'We will get back to you within 24 hours.',
      budgetLabel: 'Budget', timelineLabel: 'Timeline',
      timelines: ['As soon as possible', 'In 1–3 months', 'In 3–6 months', 'Still planning'],
      scopeOptions: ['New build / migration', 'Ongoing operations & support', '24/7 monitoring', 'Consulting & concept', 'Security & compliance', 'Scaling / performance'],
      success: 'Thank you! Your request has been received – we will be in touch shortly.',
      successTitle: 'Request sent',
      selectServiceFirst: 'Please select a service first.',
      contactError: 'Please provide name and email.',
      name: 'Name', company: 'Company', email: 'Email', phone: 'Phone', message: 'Message (optional)',
      summary: 'Your selection',
    },
    footer: {
      tagline: 'The IT platform of the future.',
      services: 'Services', company: 'Company', legal: 'Legal',
      imprint: 'Imprint', privacy: 'Privacy', terms: 'Terms', rights: 'All rights reserved.',
    },
  },
};
